export default "__VITE_ASSET__Bxo3bsft__"